module.exports = __webpack_public_path__ + "assets/logout-cover@2x.png?v=c747b3c81c194f08938ec4813012f981";